import React, { useState, useEffect } from 'react';

const ROLES = ['Administrator', 'Supervisor', 'Case Worker', 'Officer', 'Read-Only'];

function UserForm({ initialData, onSubmit, onCancel }) {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    password: '',
    role: 'Case Worker',
    isActive: true,
  });

  const isEditing = !!initialData;

  useEffect(() => {
    if (isEditing) {
      setFormData({
        fullName: initialData.full_name || '',
        email: initialData.email || '',
        password: '', // Password is not edited here
        role: initialData.role || 'Case Worker',
        isActive: initialData.is_active,
      });
    }
  }, [initialData, isEditing]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const dataToSubmit = { ...formData };
    if (isEditing) {
      delete dataToSubmit.password; // Don't send empty password on update
    }
    onSubmit(dataToSubmit);
  };

  return (
    // This is a simple modal implementation. A library like Headless UI could be used for a more robust solution.
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-lg">
        <form onSubmit={handleSubmit} className="p-6">
          <h2 className="text-xl font-bold text-slate-800 mb-4">{isEditing ? 'Edit User' : 'Create New User'}</h2>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Full Name</label>
              <input type="text" name="fullName" value={formData.fullName} onChange={handleChange} required />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Email</label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} required />
            </div>
            {!isEditing && (
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Password</label>
                <input type="password" name="password" value={formData.password} onChange={handleChange} required />
              </div>
            )}
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Role</label>
              <select name="role" value={formData.role} onChange={handleChange}>
                {ROLES.map(role => <option key={role} value={role}>{role}</option>)}
              </select>
            </div>
            {isEditing && (
              <div className="flex items-center">
                <input type="checkbox" name="isActive" id="isActive" checked={formData.isActive} onChange={handleChange} className="h-4 w-4 rounded border-gray-300 text-gold focus:ring-gold" />
                <label htmlFor="isActive" className="ml-2 block text-sm text-slate-900">User is Active</label>
              </div>
            )}
          </div>
          <div className="flex justify-end gap-4 pt-4 mt-6 border-t border-slate-200">
            <button type="button" onClick={onCancel} className="bg-slate-200 text-slate-700 hover:bg-slate-300 font-bold py-2 px-4 rounded-lg">Cancel</button>
            <button type="submit" className="bg-gold text-white hover:bg-gold-dark font-bold py-2 px-4 rounded-lg">Save User</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default UserForm;